import { useBlocNext } from "@blac/react";
import { FC } from "react";
import NotificationCardCubit from "./NotificationCardCubit";
import NotificationCardView from "./NotificationCardView";

const NotificationCard: FC = () => {
  const [{ variant, variantImage, variantImageIsWide, isVisible }] =
    useBlocNext(NotificationCardCubit);

  if (!isVisible || !variant) {
    return null;
  }

  return (
    <NotificationCardView
      variant={variant}
      variantImage={variantImage}
      variantImageIsWide={variantImageIsWide}
    />
  );
};

export default NotificationCard;
